import { AnswerAssessmentVerdict } from "../../types";

/**
 * Maps a verdict to a title-cased display label.
 *
 * @param verdict - Assessment verdict
 * @returns Human-readable verdict label
 */
export const getVerdictLabel = (verdict: AnswerAssessmentVerdict): string => {
  switch (verdict) {
    case "SATISFIES":
      return "Satisfies";
    case "VIOLATES":
      return "Violates";
    case "NOT_APPLICABLE":
      return "Not Applicable";
    case "INSUFFICIENT":
    default:
      return "Insufficient";
  }
};

/**
 * Maps a verdict to badge styles matching the Evaluation Engine design.
 *
 * @param verdict - Assessment verdict
 * @returns Tailwind classes for the verdict badge
 */
export const getVerdictClassName = (
  verdict: AnswerAssessmentVerdict,
): string => {
  switch (verdict) {
    case "SATISFIES":
      return "bg-tertiaryGreen-50 text-tertiaryGreen-700";
    case "VIOLATES":
      return "bg-tertiaryRed-50 text-tertiaryRed-600";
    case "NOT_APPLICABLE":
      return "bg-primaryGray-16 text-primaryGray-6";
    case "INSUFFICIENT":
    default:
      return "bg-secondaryYellow-11 text-secondaryYellow-2";
  }
};
